"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformObjectRegistry = void 0;
class TransformObjectRegistry {
    constructor() {
        this.objects = new Set();
        this.byKey = new Map();
    }
    register(obj) {
        if (this.objects.has(obj)) {
            throw new Error('Object already registered. Call hasObject() first to check.');
        }
        const key = obj.deduplicationKey;
        this.objects.add(obj);
        const constructor = obj.constructor;
        let typeMap = this.byKey.get(constructor);
        if (!typeMap) {
            typeMap = new Map();
            this.byKey.set(constructor, typeMap);
        }
        let objs = typeMap.get(key);
        const existing = objs?.[0];
        if (!objs) {
            objs = [];
            typeMap.set(key, objs);
        }
        objs.push(obj);
        if (key !== undefined && existing !== undefined) {
            obj.linkTo(existing);
            return false;
        }
        return true;
    }
    getPrimaries(type) {
        const typeMap = this.byKey.get(type);
        if (!typeMap) {
            return [];
        }
        let result = [];
        for (const [key, objs] of typeMap) {
            if (key === undefined) {
                result = result.concat(objs);
                continue;
            }
            const primary = objs[0];
            if (primary) {
                result.push(primary);
            }
        }
        return result;
    }
    getAllOfType(type) {
        const typeMap = this.byKey.get(type);
        if (!typeMap) {
            return [];
        }
        const result = [];
        for (const [, objs] of typeMap) {
            for (const obj of objs) {
                result.push(obj);
            }
        }
        return result;
    }
    hasObject(obj) {
        return this.objects.has(obj);
    }
    get size() {
        return this.objects.size;
    }
    getPrimaryByKey(type, key) {
        if (key === undefined) {
            throw new Error('getPrimaryByKey() called with undefined key');
        }
        const typeMap = this.byKey.get(type);
        if (!typeMap) {
            return undefined;
        }
        const objs = typeMap.get(key);
        return objs?.[0];
    }
    clear() {
        this.objects.clear();
        this.byKey.clear();
    }
}
exports.TransformObjectRegistry = TransformObjectRegistry;
//# sourceMappingURL=TransformObjectRegistry.js.map